import { useToast } from "vue-toast-notification";
import "~/assets/css/toast.css";

export default defineNuxtPlugin(() => {
	const toast = useToast({
		position: "top-right"
	});
	return {
		provide: {
			toast
		}
	};
});
